/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface EmployerUpdate {
  name?: string | null;
  description?: string | null;
  website?: string | null;
  cover_url?: string | null;
  mission_vision?: string | null;
  funding_traction?: string | null;
  culture_principles?: string | null;
  benefits?: string | null;
}
